import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BROWSER_TYPE } from "../../libs/conf";
// 扩展下该主页面的方法， 用于微信扫码打开小程序页面使用
// 定义枚举类型，通过判断小程序环境与枚举类型匹配后的重定向
enum RouteType {
  Invitation = "1",
}
const Home: React.FC = () => {
  const history = useNavigate();
  const [search] = useSearchParams();
  const routeType = search.get("type");

  React.useEffect(() => {
    if (BROWSER_TYPE.Weapp) {
      if (routeType === RouteType.Invitation) {
        history(
          `/invitation/car?no=${search.get("no")}&vin=${search.get(
            "vin"
          )}&carSeries=${search.get("carSeries")}`,
          { replace: true }
        );
      }
    }
    // eslint-disable-next-line
  }, []);
  return <div></div>;
};

export default Home;
